<template>
  <div class="container">
    <div v-for="(projectTask,index) in projectTasks" :key="index">
      <table class="table table-striped mt-3">
        <thead :class="{ 'theadNotShowing': index != 0 }">
          <tr>
            <th>Numéro d'identificateur</th>
            <th>Nom du requis</th>
            <th>Total minimum</th>
            <th>Total maximum</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ projectTask.identifierNo }}</td>
            <td>{{ projectTask.name }}</td>
            <td>{{ projectTask.totalMin }}</td>
            <td>{{ projectTask.totalMax }}</td>

            <td>
              <!-- <button
                type="submit"
                class="btn btn-action btn-sm"
                @click="edit(projectTask.taskGuid)">
                <i class="material-icons">
                  edit
                </i>
              </button>-->
              <!-- <button
                type="submit"
                class="btn btn-action btn-sm"
                @click="remove(projectTask.taskGuid)">
                <i class="material-icons">
                  delete
                </i>
              </button>-->
              <button
                type="submit"
                class="btn btn-action btn-sm"
                @click="expand(projectTask.taskGuid)"
              >
                <i v-show="expanded === projectTask.taskGuid" class="material-icons">expand_less</i>
                <i v-show="expanded != projectTask.taskGuid" class="material-icons">expand_more</i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <b-collapse :visible="projectTask.taskGuid === expanded" :id="projectTask.taskGuid">
        <div>
          <h4 style="display:inline">Tâches régulières associées:</h4>
          <div class="float-right">
            <label for="toggle">Ne pas afficher celles sans multiplicateur :</label>
            <button
              id="toggle"
              type="submit"
              class="btn btn-action btn-sm"
              @click="toggle(projectTask.taskGuid)"
            >
              <i
                v-show="toggled === projectTask.taskGuid"
                class="material-icons"
              >radio_button_checked</i>
              <i
                v-show="toggled != projectTask.taskGuid"
                class="material-icons"
              >radio_button_unchecked</i>
            </button>
          </div>
        </div>
        <br>
        <div style="overflow:auto;">
          <table class="tableData table table-responsive taskList">
            <tr>
              <th>Nom de la tâche</th>
              <td
                v-for="(task,projectRegularTaskId) in filteredRegularTasks"
                :key="projectRegularTaskId"
                v-show="(!toggled || (toggled && task.multiplicator != 0)) && task.relatedProjectRegularTaskGuid == projectTask.taskGuid"
              >{{ task.name }}</td>
            </tr>
            <tr>
              <th>Heures estimées</th>
              <td
                v-for="(task,index) in filteredRegularTasks"
                :key="index"
                v-show="(!toggled || (toggled && task.multiplicator != 0)) && task.relatedProjectRegularTaskGuid == projectTask.taskGuid"
              >{{ task.estimatedHours }}</td>
            </tr>
            <tr>
              <th>Total minimum (h)</th>
              <td
                v-for="(task,index) in filteredRegularTasks"
                :key="index"
                v-show="(!toggled || (toggled && task.multiplicator != 0)) && task.relatedProjectRegularTaskGuid == projectTask.taskGuid"
              >{{ task.timeMin }}</td>
            </tr>

            <tr>
              <th>Total maximum (h)</th>
              <td
                v-for="(task,index) in filteredRegularTasks"
                :key="index"
                v-show="(!toggled || (toggled && task.multiplicator != 0)) && task.relatedProjectRegularTaskGuid == projectTask.taskGuid"
              >{{ task.timeMax }}</td>
            </tr>
            <tr>
              <th>Multiplicateur</th>
              <td
                v-for="(task,index) in filteredRegularTasks"
                :key="index"
                v-show="(!toggled || (toggled && task.multiplicator != 0)) && task.relatedProjectRegularTaskGuid == projectTask.taskGuid"
              >
                <div
                  v-show="isEditable != task.relatedProjectRegularTaskGuid + task.projectRegularTaskId"
                >{{ task.multiplicator }}</div>
                <kez-input
                  v-show="isEditable == task.relatedProjectRegularTaskGuid + task.projectRegularTaskId"
                  :label="''"
                  v-model="editedMultiplier"
                  :no-margin="true"
                  :number="true"
                  type="number"
                  :no-label-displayed="true"
                  :no-padding="true"
                  validate="required"
                />
              </td>
            </tr>
            <tr>
              <th>Actions</th>
              <td
                v-for="(task,index) in filteredRegularTasks"
                :key="index"
                v-show="(!toggled || (toggled && task.multiplicator != 0)) && task.relatedProjectRegularTaskGuid == projectTask.taskGuid"
              >
                <button
                  v-show="isEditable != task.relatedProjectRegularTaskGuid + task.projectRegularTaskId"
                  type="submit"
                  class="btn btn-action btn-sm"
                  @click="editMultiplier(task)"
                >
                  <i class="material-icons">edit</i>
                </button>
                <button
                  v-show="isEditable == task.relatedProjectRegularTaskGuid + task.projectRegularTaskId"
                  type="submit"
                  class="btn btn-action btn-sm"
                  @click="cancel(task)"
                >
                  <i class="material-icons">cancel</i>
                </button>
                <button
                  v-show="isEditable == task.relatedProjectRegularTaskGuid + task.projectRegularTaskId"
                  type="submit"
                  class="btn btn-action btn-sm"
                  @click="save(projectTask)"
                >
                  <i class="material-icons">done</i>
                </button>
              </td>
            </tr>
          </table>
        </div>

        <ProjectSubTasks
          :project-id="projectTask.projectGuid"
          :project-task-id="projectTask.taskGuid"
        />
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import bCollapse from "bootstrap-vue/es/components/collapse/collapse";
import KezInput from "@/components/_forms/KezInput";
import ProjectSubTasks from "@/components/tasks/ProjectSubTasks";

export default {
  components: {
    KezInput,
    bCollapse,
    ProjectSubTasks
  },
  //props: ["projectTasks", "projectId"],
  data() {
    return {
      expanded: "",
      isEditable: "",
      selectedProjectTask: {
        totalMin:0,
        totalMax:0
      },
      selectedRegularTasks: [],
      toggled: false,
      editedMultiplier: null
    };
  },
  computed: {
    ...mapState("regularTasks", ["filteredRegularTasks"]),
    ...mapGetters("regularTaskTypes", ["formattedType"]),
    ...mapState("projectTasks", ["projectTask", "projectTasks"]),
  },
  mounted() {
    this.$store.dispatch("regularTasks/getListByProject", this.$route.query.id);
  },
  methods: {
    expand(guid) {
      if (this.expanded === guid) {
        this.expanded = "";
        this.toggle(guid);
      } else {
        this.expanded = guid;
      }
    },
    editMultiplier(task) {
      this.isEditable =
        task.relatedProjectRegularTaskGuid + task.projectRegularTaskId;
      this.editedMultiplier = task.multiplicator;
    },
    cancel(task) {
      this.isEditable = "";
      this.$store.dispatch("regularTasks/getListByProject", this.projectId);
    },
    completeEdit(pTask) {
      this.selectedProjectTask = pTask;
      this.selectedProjectTask.projectGuid = this.$route.query.id;
      this.filteredRegularTasks.forEach(element => {
        if (
          element.relatedProjectRegularTaskGuid ===
          this.selectedProjectTask.taskGuid
        ) {
          if (
            this.isEditable ===
            element.relatedProjectRegularTaskGuid + element.regularTaskGuid
          ) {
            // eslint-disable-next-line no-param-reassign
            element.multiplicator = this.editedMultiplier;
          }
          this.selectedRegularTasks.push(element);
        }
      });
      this.selectedProjectTask.multiplicator = this.selectedRegularTasks;
      this.$store.dispatch('setCalcul', this.selectedProjectTask.multiplicator);
    
      this.isEditable = "";
      this.selectedProjectTask = null;
      this.selectedRegularTasks = [];
    },
    toggle(guid) {
      if (this.toggled === guid) {
        this.toggled = "";
      } else {
        this.toggled = guid;
      }
    },
    isShown(guid, multiplicator) {
      if (multiplicator > 0) {
        return true;
      } else if (this.toggled === guid) {
        return false;
      }
      return true;
    },
    save(pTask) {
      this.selectedProjectTask = pTask;
      this.selectedProjectTask.projectGuid = this.$route.query.id;
      this.filteredRegularTasks.forEach(element => {
        if (
          element.relatedProjectRegularTaskGuid ===
          this.selectedProjectTask.taskGuid
        ) {
          if (
            this.isEditable ===
            element.relatedProjectRegularTaskGuid + element.projectRegularTaskId
          ) {
            // eslint-disable-next-line no-param-reassign
            element.multiplicator = this.editedMultiplier;
          }
          this.selectedRegularTasks.push(element);
        }
      });
      this.selectedProjectTask.regularTasks = this.selectedRegularTasks;
      this.$store.dispatch('projectTasks/setCalcul', this.selectedProjectTask.regularTasks);

      this.selectedProjectTask = this.projectTask;
      this.selectedProjectTask.multiplicator = this.selectedRegularTasks;

      let test = pTask;
      test.totalMin = this.selectedProjectTask.totalMin;
      test.totalMax = this.selectedProjectTask.totalMax;
      test.multiplicator = this.selectedRegularTasks;
      this.$store.dispatch("projectTasks/edit", {
        task: test
      });
      this.isEditable = "";
      this.selectedProjectTask = null;
      this.selectedRegularTasks = [];
    }
  },
};
</script>


<style scoped>
.theadNotShowing {
  visibility: collapse;
}
.tableData {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}
.taskHeader {
  display: inline;
}
.taskList {
  margin-right: 0%;
}
</style>

